import { useContext, useEffect, useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import ContentPage from "../../Content";
import separateNumber from "../../../utils/separateur";
import axios from "axios";
import DataTable from "react-data-table-component";
import ExportExcel from "../../../utils/ExcelExport";
import DetailSitesPage from "./detail_sites_page";
import moment from "moment";
import { UserContext } from "../../../utils/User_check";
import { useNavigate } from "react-router-dom";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function InventaireCaissePage(){
      const [itemsList,setItemsList] = useState([]);
      const [itemsListFilter,setItemsListFilter] = useState([]);
      const [loading, setLoading] = useState(false);
      const [newComponent,setNewComponent] = useState('list');
      const [item,setItem] = useState(null);

      const columns = [

        {
          name: "Date Creation",
          selector : row => moment(row.DateCreation).format('Do MMMM YYYY')
        },
        {
          name: "GeSite",
          selector : row => row.NomGesite
        },
    
        {
          name: "AUTEUR",
          selector : row => row.Auditeur
        },
        {
            name: "REFERENCE",
            selector : row => row.Reference
          },
        {
          name: "MONTANT (XOF)",
          selector : row => <b className="text-danger">{separateNumber(row.MontantTotal)}</b>
        },
    
        {
          name: "ACTION",
          selector : row => (
            <>
            <a className="btn btn-secondary p-2 mx-1" href={`https://bdis.distriforce.app/assets/inventairecaissegesites/${row.UrlFichier}`} target="_blank"><i class="fa-solid fa-file"></i></a>
            <button className="btn btn-primary p-2" onClick={()=> chanhePageFunction(row)}><i class="fa-solid fa-eye"></i></button>
            {/* <button className="btn btn-danger p-2 mx-1" onClick={()=> chanhePageFunction(row)}><i class="fa-regular fa-file-pdf"></i></button> */}

           
            </>
          )
        },
    
    
    
    ];

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'CAISSE ET BILLETAGE')){
          navigate('/page-no-found');
      }
    },[user]);

    useEffect(()=>{
        fetchItemsList();
      },[]);
      const fetchItemsList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/get_inventaire_caisse_gesites',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                    setItemsList(resp.data);
                    setItemsListFilter(resp.data);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
    
    const handleFilter=(event)=>{
      const datas = itemsListFilter?.filter(row => row.Auditeur.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NomGesite.toLowerCase().includes(event.target.value.toLowerCase()) || row.Reference.toLowerCase().includes(event.target.value.toLowerCase())  )  ;
      setItemsList(datas);
    }

    const conditionalRowStyles = [
        {
          when: row => row.EstPrincipal == "NON", // La condition pour colorer la ligne
          style: {
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            color: 'red',
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
    ];

    const chanhePageFunction=(row)=>{
       setItem(row);
      
       window.$('#exampleModal').modal('show');
    }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
                    <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                        <div class="d-flex align-items-center">
                        <a href="#">
                            <p class="m-0 pr-3 fs-4">Page</p>
                        </a>
                        <a class="pl-3 mr-4" href="#">
                            <p class="m-0 fs-4">Inventaire Caisses Des GeSites</p>
                        </a>
                        </div>
                        
                    </div>

                    <div class="header-left">
                        {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                        {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
                    </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header">
                      <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-6 col-md-6">
                            {/* <ExportExcel excelData={itemsList} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-success"}/> */}
                            {/* {newComponent == 'detail' && <button type="button" className="btn btn-primary mx-2" onClick={()=> setNewComponent('list')}>Retour à la liste</button> } */}
                          </div>
                  </div>
                  </div>
                  <div class="card-body">
                        <h4 class="card-title">LISTE DES INVENTAIRES</h4>
                        {newComponent == 'list' &&
                            <div class="table-responsive">
                                <DataTable 
                                    columns={columns} 
                                    data={itemsList}
                                    customStyles={customerStyle}
                                    pagination
                                    //   selectableRows
                                    progressPending={loading}
                                    conditionalRowStyles={conditionalRowStyles}
                                    progressComponent={
                                        <>
                                        <div class="text-center">
                                            <div class="spinner-border" role="status">
                                            {/* <span class="visually-hidden">Loading...</span> */}
                                            </div>
                                        </div>
                                        </>
                                    } 
                                />
                            </div>
                        }

                        {newComponent == 'detail' && 
                            <DetailSitesPage rowItem={item} />
                        }
                    
                  </div>
                </div>
              </div>

              <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="exampleModalLabel">Procès-Verbal d'Arrêté de Caisse du {moment(item?.DateCreation).format('Do/MM/y')}</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container card p-3">                            
                            <div class="row">
                              <div class="col-8">
                                  <p><strong>Reférence : {item?.Reference}</strong></p>
                                  <p><strong>Nom de l'auteur : {item?.Auditeur} </strong></p>
                                  <p><strong>Nom GeSite : {item?.NomGesite}</strong></p>
                                  <p><strong>Montant total : {separateNumber(item?.MontantTotal)} XOF</strong></p>
                              </div>
                            </div>
                        </div>

                        <div class="container card p-3 my-3">                            
                            <div class="row">
                              <div class="col-12">
                                  <p><strong>Billets et pièces :</strong></p>
                                  <table class="table table-striped table-hover">
                                      <tr className="bg-warning">
                                          <th>Catégorie</th>
                                          <th>Valeur</th>
                                          <th>Quantité</th>
                                      </tr>

                                      {item && item?.billetage?.map((row,index)=>
                                        <tr>
                                            <td className="fw-bold text-danger">{row.CategorieBilletage}</td>
                                            <td className="fw-bold text-success">{row.Designations}</td>
                                            <td className="fw-bold text-dark">{row.Nombre}</td>
                                        </tr>
                                      )}
                                     
                                  </table>
                              </div>
                            </div>
                        </div>

                        <div class="container card p-3">                            
                            <div class="row">
                              <div class="col-8">
                                  <h4>Observations : </h4>
                                  <p>{item?.Commentaire}</p>
                              </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                    </div>
                  </div>
                </div>
              </div>


            </ContentPage>
        </>
    );

}

export default InventaireCaissePage;